//@ts-nocheck
export const webmenu = {
    wOptions: {},
    parseLayout: function (webmenu, options) {
        const menugroups = [];
        /*const {useLogo, logoSrc, logoPos} = options*/
        this.wOptions.useLogo = options.useLogo;
        this.wOptions.logoSrc = options.logoSrc;
        this.wOptions.logoPos = options.logoPos;
        this.wOptions.useModuleInfo = options.useModuleInfo;
        this.wOptions.useBorder = options.useBorder;
        this.wOptions.textAlign = options.textAlignment;
        this.wOptions.active = {
            activeRefNo: options.activeTab,
            use: options.activeTab > 0,
            color: options.activeColor,
        };
        for (let i = 0; i < webmenu.length; i++) {
            const menu = this.createMenuGroup(webmenu[i]);
            menugroups.push(menu);
        }
        if (this.wOptions.useLogo) {
            let logo = document.createElement('img');
            logo.src = this.wOptions.logoSrc;
            logo.classList.add('pic-webmenu-logo');
            if (this.wOptions.logoPos === 'right') {
                logo.classList.add('webmenu-logo-right');
                menugroups.push(logo);
            }
            else {
                // if (logoPos !== 'left') console.warn(`Position ${logoPos} invalid for logo, defaulting to 'left'`);
                if (this.wOptions.logoPos !== 'left')
                    console.warn('Position defaulted to left from: ' + logoPos);
                logo.classList.add('webmenu-logo-left');
                menugroups.unshift(logo);
            }
        }
        let validAlignments = ['left', 'center', 'right'];
        if (validAlignments.indexOf(this.wOptions.textAlign) === -1)
            this.wOptions.textAlign = 'center';
        document
            .getElementById('pic-webmenu-maindropdown')
            .classList.add('dropdown-alignment-' + this.wOptions.textAlign);
        if (this.wOptions.useModuleInfo) {
            console.log('Creating Module Info');
            let moduleInfo = this.wOptions.logoPos === 'right'
                ? this.createModuleInfo('left')
                : this.createModuleInfo('right');
            console.log(moduleInfo);
            menugroups.push(moduleInfo);
        }
        if (this.wOptions.active.activeRefNo > -1 && this.wOptions.active.use)
            this.setActiveNavTab(menugroups);
        return menugroups;
    },
    createMenu: function (menu) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.textContent = menu.txt;
        if (menu.event) {
            let event;
            if (+menu.event == menu.event)
                event = menu.event;
            else
                event = atob(menu.event);
            if (event.startsWith('loadPage(')) {
                let spltEvnt = event.replace(/"/g, '');
                spltEvnt = spltEvnt
                    .substring(spltEvnt.indexOf('(') + 1, spltEvnt.indexOf(')'))
                    .split(',');
                a.addEventListener('click', function (e) {
                    loadPage(spltEvnt[0], spltEvnt[1]);
                });
            }
            else {
                a.addEventListener('click', function (e) {
                    console.log('test wemenu 1');
                    doSubmit(event);
                });
            }
        }
        li.appendChild(a);
        if (menu.subs && menu.subs.length > 0) {
            let circle = document.createElement('span');
            circle.textContent = '\u2B24';
            li.appendChild(circle);
            li.classList.add('webmenu-hasdropdown');
            const ul = document.createElement('ul');
            a.addEventListener('mouseover', function (e) {
                let main = { width: window.innerWidth, height: window.innerHeight };
                let newUL = e.target.nextElementSibling.nextElementSibling;
                if (!newUL._open)
                    newUL._open = {};
                //console.log(main, dimensionsUl)
                newUL.style.left =
                    ''; /* RESET style so that up/down is not calculated from the incorrect view */
                newUL.style.top = '';
                newUL._open.horizontal = 'right';
                let dimensionsUl = newUL.getBoundingClientRect(); /* y/x is not supported in IE11 */
                let openDown = dimensionsUl.top + dimensionsUl.height <= main.height;
                let openRight = dimensionsUl.left + dimensionsUl.width <= main.width;
                // console.log(e.target.textContent + ' > open right: '+ openRight +' | open down: ' + openDown)
                if (!openRight ||
                    (newUL.parentElement.parentElement &&
                        newUL.parentElement.parentElement._open.horizontal == 'left')) {
                    newUL.style.left = '-' + newUL.scrollWidth + 'px';
                    newUL._open.horizontal = 'left';
                }
                if (!openDown) {
                    if (dimensionsUl.top - newUL.scrollHeight < 0)
                        newUL.style.top = '-' + (dimensionsUl.top - 5) + 'px';
                    else
                        newUL.style.top = '-' + (newUL.scrollHeight - 35) + 'px';
                }
            });
            for (let i = 0; i < menu.subs.length; i++) {
                const subli = this.createMenu(menu.subs[i]);
                ul.appendChild(subli);
            }
            li.appendChild(ul);
        }
        return li;
    },
    createMenuGroup: function (menugrp) {
        let txt, event, submenus, refno, isActive;
        txt = menugrp.txt;
        submenus = menugrp.subs;
        refno = menugrp.refNo;
        isActive = menugrp.isActive;
        if (isActive) {
            this.wOptions.active.activeRefNo = refno;
            this.wOptions.active.use = false;
        }
        try {
            event = atob(menugrp.event);
        }
        catch (err) {
            console.log('Error, using blank for event\n', err);
            event = '';
        }
        const topli = document.createElement('li');
        topli.classList.add('webmenu-hasdropdown');
        topli.classList.add('topli');
        if (this.wOptions.useBorder)
            topli.classList.add('topborder');
        const a = document.createElement('a');
        const topul = document.createElement('ul');
        topul.classList.add('webmenu-maindropdown');
        topul._open = { horizontal: 'right' };
        a.textContent = txt;
        a._refNo = refno;
        if (isActive)
            console.log(menugrp);
        if (isActive) {
            if (this.wOptions.active.color)
                a.style.setProperty('--active-color', this.wOptions.active.color);
            a.classList.add('active-nav');
        }
        if (event) {
            //js event handling
            a._eventRef = event;
            /*if (event.startsWith('function')) {*/
            if (event.match(/function/)) {
                let params = [], body;
                params = event
                    .substring(event.indexOf('(') + 1, event.indexOf(')'))
                    .split(',');
                body = event.substring(event.indexOf('{') + 1, event.lastIndexOf('}'));
                console.log('test wemenu 2', body, params, a);
                a.addEventListener('click', new Function(params, body)); /* where did the event go?, technically the param does nothing, it only uses function(event) */
            }
            else if (event.length === 0) {
            }
            //progress event handling
            else {
                a.addEventListener('click', function (e) {
                    sessionStorage.setItem('active-nav', e.target._eventRef);
                    doSubmit(event);
                });
            }
        }
        topli.appendChild(a);
        for (let i = 0, l = submenus.length; i < l; i++) {
            const submenu = this.createMenu(submenus[i]);
            topul.appendChild(submenu);
        }
        topli.appendChild(topul);
        return topli;
    },
    createModuleInfo: function (position) {
        const moduleName = sessionStorage.getItem('moduleName') || '';
        const moduleNameSub = sessionStorage.getItem('moduleNameSub') || '';
        if (moduleName == '' || moduleNameSub == '')
            console.warn('useModuleName used with at least 1 empty name');
        let moduleDiv = document.createElement('div');
        moduleDiv.classList.add('modname-main');
        moduleDiv.classList.add('modname-' + position);
        let mainName = document.createElement('span');
        mainName.classList.add('modname-title');
        mainName.textContent = moduleName;
        let subName = document.createElement('span');
        subName.textContent = moduleNameSub;
        let usrName = document.createElement('span');
        usrName.classList.add('modname-user');
        let user = sessionStorage.getItem('userid') ||
            document.getElementsByName('SessionCode')[0].value.split('.')[1];
        usrName.textContent = user;
        moduleDiv.appendChild(mainName);
        moduleDiv.appendChild(subName);
        moduleDiv.appendChild(usrName);
        return moduleDiv;
    },
    setActiveNavTab: function (el) {
        console.log('Setting actnav', el);
        console.time('setact');
        let that = this;
        /*alt -> li.selAll('li a').find(x=refno)*/
        el.filter(function (x) {
            return x.nodeName === 'LI';
        }).forEach(function (li) {
            let anchorArray = li.querySelectorAll('a');
            console.log('as', anchorArray);
            for (let i = 0; i < anchorArray.length; i++) {
                let element = anchorArray[i];
                if (element._refNo == that.wOptions.active.activeRefNo) {
                    if (this.wOptions.active.color)
                        element.style.setProperty('--active-color', this.wOptions.active.color);
                    element.classList.add('active-nav');
                    console.log('Active nav:', element);
                    break;
                }
            }
        });
        console.timeEnd('setact');
    },
};
//# sourceMappingURL=webmenu.js.map